package com.jingfangpai.common.coroutines

import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.Dispatchers

public actual val applicationDispatcher: CoroutineDispatcher = Dispatchers.Default
